import { render } from "./HeroiconsSolidRewind.vue?vue&type=template&id=59f1d0bd"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidRewind.vue"]])

export default __exports__